// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"436":"15d56b6e","970":"881bd795"}[chunkId] + ".js";
};